export const getInitialState = () => {
  return {
    location: undefined,
    prevLocation: undefined,
  }
}

export const getLocation = (state) => state.location
